import { parseAbi } from 'viem';

// MoltEscrowV2 Contract (Base mainnet)
// USDC-based escrow with backend relayer pattern
export const MOLT_ESCROW_ADDRESS = (import.meta.env.VITE_ESCROW_ADDRESS ||
  '0x3a57faee4EE95444506a6E290261D4C37b3060Be') as `0x${string}`;

// Base mainnet USDC Token
export const USDC_ADDRESS = '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913' as `0x${string}`;

// MoltEscrowV2 ABI (bytes32 jobId, USDC-based)
export const MOLT_ESCROW_ABI = parseAbi([
  'event Deposited(bytes32 indexed jobId, address indexed poster, uint256 amount, uint256 platformFee)',
  'event AgentAssigned(bytes32 indexed jobId, address indexed agent)',
  'event Released(bytes32 indexed jobId, address indexed agent, uint256 amount)',
  'event Refunded(bytes32 indexed jobId, address indexed poster, uint256 amount)',
  'event DisputeOpened(bytes32 indexed jobId)',
  'event DisputeResolved(bytes32 indexed jobId, uint256 posterBps, uint256 agentBps)',
  'function deposit(bytes32 jobId, uint256 amount) external',
  'function dispute(bytes32 jobId) external',
  'function escrows(bytes32) external view returns (address poster, address agent, uint256 amount, uint256 platformFee, uint256 depositTime, bool agentAssigned, bool released, bool refunded, bool disputed, bool disputeResolved)',
  'function platformFees() external view returns (uint256)',
  'function platformFeeBps() external view returns (uint256)',
  'function PLATFORM_FEE_BPS() external view returns (uint256)',
  'function usdc() external view returns (address)',
]);

// USDC Token ABI (minimal interface for approve/allowance/balanceOf)
export const USDC_ABI = parseAbi([
  'function approve(address spender, uint256 amount) external returns (bool)',
  'function allowance(address owner, address spender) external view returns (uint256)',
  'function balanceOf(address account) external view returns (uint256)',
  'function decimals() external view returns (uint8)',
]);
